import { createFileRoute } from "@tanstack/react-router";
import type { THREEViewerOptions } from "gfx/THREEViewer";
import {
  DESIGN_MATERIAL_TEST_CAMERA_SETTINGS,
  DESIGN_MATERIAL_TEST_KEYS,
  addDesignMaterialTestGeometry,
} from "test/util/designMaterialTestUtil";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import withAuthentication from "../../components/withAuthentication";

function DesignMaterialTestPage() {
  const options: Partial<THREEViewerOptions> = {
    cameraSettings: DESIGN_MATERIAL_TEST_CAMERA_SETTINGS,
    useMSAA: false,
    ssfxRenderer: true,
  };

  return (
    <HeadlessRenderTestPage
      testName="Design material render"
      options={options}
      testKeys={DESIGN_MATERIAL_TEST_KEYS}
      addGeometry={addDesignMaterialTestGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/design-material")({
  component: withAuthentication(DesignMaterialTestPage, { superAdmin: true }),
});
